<template>
	<div class="main">
    <section class="panel" v-if="isShowTreaty">
      <treaty :key="$route.fullPath" type="weak"></treaty>
    </section>
		<section class="panel" v-else>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="name" class="col-sm-4 col-xs-2 column-required">姓名</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.name}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="name" name="name" v-validate="'required'" v-model="stu.name" type="text" class="form-control" maxlength="20"/>
							<span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="sex" class="col-sm-4 col-xs-2 column-required">性別</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.sex == 'M' ? '男' : '女'}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="sex" name="sex" ref="sex" v-validate="'required'" v-model="stu.sex" class="form-control">
								<option value="">請選擇</option>
								<option value="M">男</option>
								<option value="F">女</option>
							</select>
							<span class="text-danger" v-show="errors.has('sex')">{{ errors.first('sex') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="account" class="col-sm-4 col-xs-2">學號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.account}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="account" name="account" v-model="stu.account" type="text" class="form-control" @input="getLastYearData"/>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="idno" class="col-sm-4 col-xs-2 column-required">身分證字號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.idno}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="idno" name="idno" v-validate="'required|idnoSex:sex'" v-model="stu.idno" type="text" class="form-control" maxlength="10"/>
							<span class="text-danger" v-show="errors.has('idno')">{{ errors.first('idno') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="ssym" class="col-sm-4 col-xs-2">學制</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{ssymList.some(ssym => ssym.commCode == stu.ssym) ?
							ssymList.filter(ssym => ssym.commCode == stu.ssym)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="ssym" name="ssym" v-model="stu.ssym" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dept" class="col-sm-4 col-xs-2">科系</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{deptList.some(dept => dept.commCode == stu.dept) ?
							deptList.filter(dept => dept.commCode == stu.dept)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dept" name="dept" v-model="stu.dept" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="drade" class="col-sm-4 col-xs-2">年級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeList.some(drade => drade.key == stu.drade) ?
							dradeList.filter(drade => drade.key == stu.drade)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="drade" name="drade" v-model="stu.drade" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dradeClass" class="col-sm-4 col-xs-2">班級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeClassList.some(dradeClass => dradeClass.key == stu.dradeClass) ?
							dradeClassList.filter(dradeClass => dradeClass.key == stu.dradeClass)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dradeClass" name="dradeClass" v-model="stu.dradeClass" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeClassList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="state" class="col-sm-4 col-xs-2">在學狀態</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{uStateList.some(uState => uState.commCode == stu.state) ?
							uStateList.filter(uState => uState.commCode == stu.state)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="state" name="state" v-model="stu.state" class="form-control" disabled>
								<option v-for="(item,key) in uStateList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryYear" class="col-sm-4 col-xs-2">入學年</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryYear}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryYear" name="entryYear" v-model="stu.entryYear" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryMonth" class="col-sm-4 col-xs-2">入學月</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryMonth}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryMonth" name="entryMonth" v-model="stu.entryMonth" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="phone" class="col-sm-4 col-xs-2">行動電話</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.phone}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="phone" name="phone" v-model="stu.phone" type="text" class="form-control" />
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-6 form-group">
						<label for="schMail" class="col-sm-2 col-xs-2">學校信箱</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.schMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="schMail" name="schMail" v-model="stu.schMail" type="email" class="form-control" />
						</div>
					</div>
					<div class="col-md-6 form-group">
						<label for="extMail" class="col-sm-2 col-xs-2 column-required">個人信箱</label>
						<div v-if="!isEditable" class="col-sm-8 col-xs-10">{{stu.extMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="extMail" name="extMail" v-validate="'required'" v-model="stu.extMail" type="email" class="form-control" />
							<span class="text-danger" v-show="errors.has('extMail')">{{ errors.first('extMail') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="isInfo">
						<label class="col-xs-3">地址</label>
						<div class="col-xs-9 col-md-10">
							{{ stu.resiFullAddress }}
						</div>
					</div>
					<div class="col-md-12 form-group" v-else>
						<label class="col-xs-2 col-md-1 form-group">地址</label>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiCityId" name="resiCityId"  class="form-control" @change="getResiArea()">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
								</option>
							</select>
						</div>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiAreaId" name="resiAreaId"  class="form-control">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
								</option>
							</select>
						</div>
						<div class="col-xs-offset-util-3 col-xs-9 col-md-7 form-group">
							<input type="text" id="resiAddr" name="resiAddr" class="form-control" v-model="stu.resiAddr" placeholder="地址" maxlength="100"/>
						</div>
					</div>
				</div>
				<div class="row form-group col-md-12">
					<table class="table table-no-more table-bordered table-striped mb-none">
						<thead>
							<tr>
								<th class="text-center" style="width: 3%">序號</th>
								<th class="text-center" style="width: 25%;">學生關係人</th>
								<th class="text-center" style="width: 20%;">姓名</th>
								<th class="text-center" style="width: 20%;">身分證字號</th>
								<th class="text-center" style="width: 20%;">職業</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(kinship, index) in weakApply.kinshipList" :key="index">
								<td data-title="序號" class="text-center" style="vertical-align: middle;" :class="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'column-required' : ''">{{index + 1}}</td>
								<td data-title="學生關係人" class="text-center">
                  <div :class="isKinshipDeletable(kinship) ? 'col-xs-1' : ''" :style="isKinshipDeletable(kinship) ? '' : 'display:none'">
                    <a @click="clearKinship(index)"><i class="fa fa-trash" style="font-size: 2rem;padding-top: 5px;"></i></a>
                  </div>
									<div :class="isKinshipDeletable(kinship) ? 'col-xs-6' : 'col-xs-7'">
										<select :id="'kinshipType_'+index" :name="'kinshipType_'+index" :ref="'kinshipType_'+index" v-model="kinship.kinshipType" v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`kinshipType_${index}`)">{{ errors.first(`kinshipType_${index}`) }}</span>
									</div>
									<div class="col-xs-5">
										<select :id="'status_'+index" :name="'status_'+index" v-model="kinship.status"  v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.status != 'O'){kinship.statusValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipStateList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`status_${index}`)">{{ errors.first(`status_${index}`) }}</span>
									</div>
								</td>
								<td data-title="姓名" style="vertical-align: middle;">
									<input :id="'name_'+index" :name="'name_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.name" type="text" class="form-control" :disabled="!isEditable" maxlength="20">
									<span class="text-danger" v-show="errors.has(`name_${index}`)">{{ errors.first(`name_${index}`) }}</span>
								</td>
								<td data-title="身分證字號" style="vertical-align: middle;">
									<input :id="'idNo_'+index" :name="'idNo_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O' && kinship.status != 'D') ? `required|kinIdnoSex:kinshipType_${index}` : ''" v-model="kinship.idNo" type="text" class="form-control" :disabled="!isEditable" maxlength="10"
									@input="(e) => {kinship.idNo = e.target.value.toUpperCase()}">
									<span class="text-danger" v-show="errors.has(`idNo_${index}`)">{{ errors.first(`idNo_${index}`) }}</span>
								</td>
								<td data-title="職業" class="text-center">
									<div class="col-xs-6">
										<select :id="'occupationType_'+index" :name="'occupationType_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.occupationType" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.occupationType != 'O'){kinship.occupationValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipOccupationList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`occupationType_${index}`)">{{ errors.first(`occupationType_${index}`) }}</span>
									</div>
									<div class="col-xs-6">
										<input :id="'occupationValue_'+index" :name="'occupationValue_'+index" v-model="kinship.occupationValue" :disabled="!(kinship.occupationType == 'O' && isEditable)"
										v-validate="kinship.occupationType == 'O'? 'required' : ''" type="text" class="form-control" maxlength="10">
										<span class="text-danger" v-show="errors.has(`occupationValue_${index}`)">{{ errors.first(`occupationValue_${index}`) }}</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row form-group">
					<div class="col-md-9 form-group">
						<label class="col-sm-2 col-xs-2 column-required">上學期學業成績</label>
						<div class="col-sm-10 col-xs-10 form-inline">
							<label for="lastSmtrScore">
								<input id="lastSmtrScore" name="lastSmtrScore" v-model="weakApply.lastSmtrScore" v-validate="weakApply.lastSmtrType == '' ? 'required|min_value:60' : ''" :disabled="!isEditable" type="number" style="width: 80px;" class="form-control"
								@input="(val) => {if(val != '') {weakApply.lastSmtrType = ''}}"/>
								<span>(未達60分無法申請)</span>
							</label>
							<label for="lastSmtrType_1">
								<input id="lastSmtrType_1" name="lastSmtrType_1" value="1" v-validate="weakApply.lastSmtrScore == '' ? 'required' : ''" v-model="weakApply.lastSmtrType" type="radio" class="radio-custom" :disabled="!isEditable"
								@change="() => {weakApply.lastSmtrScore = ''}"/>
								<span>新生免計成績</span>
							</label>
							<label for="lastSmtrType_2">
								<input id="lastSmtrType_2" name="lastSmtrType_2" value="2" v-validate="weakApply.lastSmtrScore == '' ? 'required' : ''" v-model="weakApply.lastSmtrType" type="radio" class="radio-custom" :disabled="!isEditable"
								@change="() => {weakApply.lastSmtrScore = ''}"/>
								<span>轉學生免計成績</span>
							</label>
							<span class="text-danger" v-show="errors.has('lastSmtrScore')">分數不得小於 60 </span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-9 form-group">
						<label for="householdFile" class="col-sm-4 col-xs-2 column-required">
							3個月內戶籍謄本或新式戶口名簿上傳(皆含詳細記事)<br/>
							<a href="javascript:;" class="btn-link" @mouseover="display()" @mouseout="disappear()">上傳範例</a>
							<div id="box" class="box" style="z-index:1000;"><h4 class="blue">新式戶口名簿樣本</h4><img src="../../../../assets/images/1595926019829.jpg" width="500px"></div>
						</label>
						<div v-if="householdFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.householdFile}}
                <a v-if="isEditable" type="button" @click="() => {householdFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(weakApply.householdFile)" :href="getPreviewUrl(weakApply.householdFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(weakApply.householdFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(weakApply.householdFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(weakApply.householdFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="householdFile" name="householdFile" accept=".pdf,image/*" @change="getHouseholdFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('householdFile')">{{ errors.first('householdFile') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="!isShowPrintBtn">
					<div class="col-md-9 form-group">
						<label for="affidavitFile" class="col-sm-4 col-xs-2 column-required">
							上傳申請書(請檢查申請書是否已簽名)<br/>
						</label>
						<div v-if="affidavitFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.affidavitFile}}
                <a v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')) ||
							 ((weakApply.schReviewState == '1' || weakApply.schReviewState == '6') && isAdmin('assist')))" type="button" @click="() => {affidavitFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(weakApply.affidavitFile)" :href="getPreviewUrl(weakApply.affidavitFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(weakApply.affidavitFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(weakApply.affidavitFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(weakApply.affidavitFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="affidavitFile" name="affidavitFile" accept=".pdf,image/*" @change="getAffidavitFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('affidavitFile')">{{ errors.first('affidavitFile') }}</span>
						</div>
					</div>
				</div>
        <div v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState" class="row form-group">
          <div class="col-sm-12">
            <label>隱私權及個人資料保護政策宣告：{{ (customFormatter(weakApply.crDate, "YYYY")-1911) + customFormatter(weakApply.crDate, "年MM月DD日") }} 第{{ !!weakApply.privacyTreatyVersion ? weakApply.privacyTreatyVersion : "1.0" }}版</label>
          </div>
        </div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">學校初審</h4>
					</div>
				</div>
        <div class="row form-group" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-md-9 form-group">
            <label for="discardIncomeFile" class="col-sm-4 col-xs-2">
              不列計所得切結書
            </label>
            <div v-if="discardIncomeFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.discardIncomeFile}}
                <a v-if="isEditable" type="button" @click="() => {discardIncomeFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
              <a v-if="IsPdf(weakApply.discardIncomeFile)" :href="getPreviewUrl(weakApply.discardIncomeFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
              <div v-else-if="IsValidPreviewExt(weakApply.discardIncomeFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
                <a :href="getPreviewUrl(weakApply.discardIncomeFile)" target="_blank">
                  <img class="img-fluid" :src="getPreviewUrl(weakApply.discardIncomeFile)" alt="" style="width:200px; "/>
                </a>
              </div>
            </div>
            <div v-else class="col-sm-8 col-xs-10">
              <input type="file" id="discardIncomeFile" name="discardIncomeFile" accept=".pdf,image/*" @change="getDiscardIncomeFile($event)" />
              <span class="text-danger" v-show="errors.has('discardIncomeFile')">{{ errors.first('discardIncomeFile') }}</span>
            </div>
          </div>
        </div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-3">
						<select id="schReviewState" name="schReviewState" v-validate="'required'" v-model="weakApply.schReviewState" class="form-control" :disabled="!isAdmin('assist')">
							<option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
							</option>
						</select>
						<span v-if="(weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')">若需調整申請書以外的資訊，請點擊下方「編輯資料」。</span>
					</div>
				</div>
				<div v-if="weakApply.schReviewState == '3' || weakApply.schReviewState == '4' || weakApply.schReviewState == '5'" class="row form-group">
					<div class="col-sm-12">
						<label for="schReviewContent">{{schreviewStateList.filter(state => state.commCode == weakApply.schReviewState)[0].commValue}}說明</label>
						<textarea id="schReviewContent" name="schReviewContent" v-model="weakApply.schReviewContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
						</textarea>
					</div>
					<hr/>
				</div>
        <hr/>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">教育部(財稅中心)審核紀錄</h4>
					</div>
				</div>
				<div class="row form-group col-md-12" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
						<div class="col-lg-2">
							查核級別：{{getClassText(weakApply.moeReviewClass)}}
						</div>
						<div class="col-lg-2">
							利息級距：
              <span :style="weakApply.moeReviewInterest == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReviewInterest}}</span>
						</div>
						<div class="col-lg-2">
							土地不動產級距：
              <span :style="weakApply.moeReviewEstate == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReviewEstate}}</span>
						</div>
						<div class="col-lg-2" >
							查核結果：
              <span :style="weakApply.moeReview == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReview}}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">補助金發放部別及金額</h4>
					</div>
				</div>
				<div class="row form-group col-md-12" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
						<div class="col-lg-2">
							發放部別：{{weakApply.moeReviewMinistry}}
						</div>
						<div class="col-lg-2">
							已發放金額：{{weakApply.paidAmount}}
						</div>
						<div class="col-lg-2">
							弱勢補助金額：{{weakApply.weakAmount}}
						</div>
						<div class="col-lg-2">
							學校自籌金額：{{weakApply.schAmount}}
						</div>
						<div class="col-lg-2">
							教育部補助金額：{{weakApply.moeAmount}}
						</div>
					</div>
          <hr/>
          <div class="row form-group">
            <div class="col-sm-6">
              <div class="col-sm-3">放棄</div>
              <div class="col-sm-3" style="display: flex;">
                <div class="checkbox-custom">
                  <input id="abandon" name="abandon" type="checkbox" value="Y" v-model="weakApply.abandon"  :disabled="!isAdmin('assist')">
                  <label for="abandon">是</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-sm-6" v-if="weakApply.abandon">
              <label  class="col-sm-3" for="abandonContent">放棄說明</label>
              <div class=" col-sm-6">
                  <textarea id="abandonContent" name="abandonContent" v-model="weakApply.abandonContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
                  </textarea>
              </div>
            </div>
          </div>
					<hr/>
				</div>
				<div v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">繳費資訊{{!!feeInfoError ? `(${feeInfoError})` : ''}}</h4>
							<a v-if="feeInfoError == '沒有該學生申請學期的費用資料'" class="btn-link" style="cursor: pointer;" @click="syncSchoolFee()">同步學雜費資料</a>
						</div>
					</div>
					<div class="row form-group col-md-12" style="display: grid;float: inherit;">
						<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
							<div class="col-lg-2">
								應收學費總額：{{weakApply.feeInfo.totleTuition}}
							</div>
							<div class="col-lg-2">
								銀行金額：{{weakApply.feeInfo.paymoneyCash}}
							</div>
							<div class="col-lg-2">
								出納金額：{{weakApply.feeInfo.paymoney}}
							</div>
							<div class="col-lg-2">
								就學貸款：{{weakApply.feeInfo.realloan}}
							</div>
							<div class="col-lg-2">
								繳費日期：{{weakApply.feeInfo.paydate}}
							</div>
						</div>
					</div>
					<hr/>
				</div>
        <div class="row form-group" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-sm-12">
            <h4 style="font-weight: bold;">退費選項</h4>
          </div>
        </div>
        <div class="row form-group"  v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-sm-6">
            <div class="col-sm-3">是否為修、退學學生</div>
            <div class="col-sm-3" style="display: flex;">
              <div class="checkbox-custom">
                <input id="isRefund" name="isRefund" type="checkbox" value="Y" v-model="weakApply.isRefund">
                <label for="isRefund">是</label>
              </div>

            </div>
          </div>
        </div>
				<div class="text-center form-group" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || weakApply.schReviewState == '4'|| weakApply.schReviewState == '5') && isShowPrintBtn">
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('weak.list')">返回</button>
					<button class="btn s_btn_o" @click="handleSave(true)">儲存</button>
					<button class="btn s_btn_o" @click="handleSave()">儲存並預覽列印</button>
				</div>
				<div class="text-center form-group" v-else>
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('weak.list')">返回</button>
					<button class="btn s_btn_g" @click="showPrintPopup(true)" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')))">列印申請書</button>
					<button class="btn s_btn_g" @click="backToEdit()" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')))">編輯資料</button>
					<button class="btn s_btn_o" @click="handleSave()" v-if="!weakApply.schReviewState || weakApply.schReviewState == '0' || weakApply.schReviewState == '4' || weakApply.schReviewState == '5' || isAdmin('assist')">送出</button>
				</div>
            </div>
		</section>
		<printPopup v-if="isShowPrintPopup"/>
	</div>
</template>
<script>
import printPopup from "./printPopup";
import treaty from "@/components/assist/treaty";
export default {
	components:{
		printPopup,
    treaty
	},
	data(){
		return {
			stu: {
				idno: "",
				name: "",
				sex: "",
				account:"",
				ssym: "",
				dept: "",
				drade: "",
				dradeClass: "",
				state: "01",
				entryYear: "",
				entryMonth: "",
				phone: "",
				schMail: "",
				extMail: "",
				resiAddr: "",
				resiCityId: "",
				resiAreaId: "",
				deptCode: "",
			},
			weakApply:{
				id: "",
				kinshipList: [
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					}
				],
				lastSmtrScore: null,
				lastSmtrType: "",
				affidavitFile: "",
				householdFile: "",
        discardIncomeFile: "",
				schReviewState: "",
				schReviewContent: "",
				moeReviewClass: "",
				moeReviewInterest: "",
				moeReviewEstate: "",
				moeReview: "",
				moeReviewMinistry: "",
				moeReviewDesc: "",
				paidAmount: null,
				weakAmount: null,
				schAmount: null,
				moeAmount: null,
				isRefund: false,
				feeInfo: {},
        abandon: false,
        abandonContent: ""
			},
			// 下拉選單來源
			ssymList: [],
			deptList: [],
			cityList: [],
			areaList: [],
			weakKinshipList: [],
			weakKinshipStateList: [],
			weakKinshipOccupationList: [],
			weakScoreList: [],
			schreviewStateList: [],
			uStateList: [],
			dradeList: [
				{
					key: "1",
					value: "一年級"
				},
				{
					key: "2",
					value: "二年級"
				},
				{
					key: "3",
					value: "三年級"
				},
				{
					key: "4",
					value: "四年級"
				},
				{
					key: "5",
					value: "五年級"
				},
				{
					key: "6",
					value: "六年級"
				},
				{
					key: "7",
					value: "七年級"
				},
				{
					key: "8",
					value: "八年級"
				},
				{
					key: "9",
					value: "九年級"
				}
			],
			dradeClassList: [
				{
					key: "A",
					value: "A班"
				},
				{
					key: "B",
					value: "B班"
				},
				{
					key: "C",
					value: "C班"
				},
        {
          key: "D",
          value: "D班"
        },
			],
			//檔案
			householdFile: "",
			stuPhoto: "",
			affidavitFile: "",
      discardIncomeFile: "",
			householdFilePreview: "",
			affidavitFilePreview: "",
      discardIncomeFilePreview: "",

			// 判斷是否顯示列印按鈕
			isShowPrintBtn: false,

			// 判斷是否顯示列印畫面
			isShowPrintPopup: false,

			// 透過身分證字號查詢進入
			isFromIdnoSearch: false,

			// 顯示費用資料錯誤訊息
			feeInfoError: "",

      // 是否顯示條約
      isShowTreaty: false
		}

	},
	mounted(){
    if(this.$route.name == "weak.apply.new") {
      this.isShowTreaty = true;
    }
		this.pageInit();
	},
	methods:{
		pageInit(){
			let api = `/api/weak/editInit?isNew=${this.$route.name == "weak.apply.new"}`;
			this.$axios.get(api).then(res => {
				if (res.data.status == "success") {
					this.ssymList = res.data.data.selectList.ssym
					this.deptList = res.data.data.selectList.dept
					this.cityList = res.data.data.selectList.city
					this.weakKinshipList = res.data.data.selectList.weakKinship
					this.weakKinshipStateList = res.data.data.selectList.weakKinshipState
					this.weakKinshipOccupationList = res.data.data.selectList.weakKinshipOccupation
					this.weakScoreList = res.data.data.selectList.weakScore
					this.schreviewStateList = res.data.data.selectList.reviewState
					this.uStateList = res.data.data.selectList.uState

					if (this.getStore(this.$route.name) != null) {
						let storeData = JSON.parse(this.getStore(this.$route.name));
						if(storeData.weakApplyId != ""){
							api = `/api/weak/${storeData.weakApplyId}`;
							this.$axios.get(api).then(res => {
								this.stu = {
									...res.data.data.stu,
									ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
									dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
								};
								this.weakApply = {
									...res.data.data.wa,
									feeInfo: res.data.data.wa.feeInfo == null ? {} : JSON.parse(res.data.data.wa.feeInfo)
								};

								// 補足三個關係人資料
								for(let i=0; i<3; i++){
									if(this.weakApply.kinshipList.length <= i ){
										this.weakApply.kinshipList[i] = {
											kinshipType: "",
											status: "",
											occupationType: ""
										}
									}
								}

								// 建立預覽連結
								this.householdFilePreview = this.getPreviewUrl(this.weakApply.householdFile);
                this.discardIncomeFilePreview = this.getPreviewUrl(this.weakApply.discardIncomeFile);
								this.affidavitFilePreview = this.getPreviewUrl(this.weakApply.affidavitFile);

                // 計算費用資訊
                if(JSON.stringify(this.weakApply.feeInfo) == '{}') {
                  this.calcFeeInfo();
                }
							});
						}

						if(storeData.isFromIdnoSearch != "") {
							this.isFromIdnoSearch = storeData.isFromIdnoSearch
						}
					} else {
						this.isShowPrintBtn = true;
					}


					if (this.$route.name == "weak.apply.new" && this.sessionData.accountType == "STU"){
						this.stu = {
							...res.data.data.stu,
							ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
							dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
						};

						if(res.data.data.lastWeakApply != null && res.data.data.lastWeakApply.id != "") {
							this.weakApply.kinshipList = res.data.data.lastWeakApply.kinshipList;
              this.weakApply.discardIncomeFile = res.data.data.lastWeakApply.discardIncomeFile;

              // 補足三個關係人資料
							for(let i=0; i<3; i++){
								if(res.data.data.lastWeakApply.kinshipList.length <= i ){
									this.weakApply.kinshipList[i] = {
										kinshipType: "",
										status: "",
										occupationType: ""
									}
								}
							}
						}
					}


				} else if(res.data.status == "error"){
					bootbox.alert(res.data.msg);
					this.$router.back();
				}
			});
		},
    calcFeeInfo() {
      if(this.isAdmin('assist') && !(!this.weakApply.schReviewState || this.weakApply.schReviewState == '0')) {
        const api = "/api/weak/calc";
        const body = {
          ...this.weakApply,
          payInfo: '{}',
          feeInfo: '{}'
        }
        this.$axios.post(api, body).then(res => {
          if(res.data.status === "success") {
            this.weakApply.feeInfo = res.data.data;
            this.feeInfoError = "";
          } else if(res.data.status === "error") {
            this.feeInfoError = res.data.msg;
          }
        });
      }
    },
		handleSave(withoutPrint = false){
      var orgKinshipList = this.weakApply.kinshipList;
      this.weakApply.kinshipList = this.weakApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin));
			this.$validator.validateAll().then((result) => {
				if (result) {
					if(this.weakApply.id === ""){
						this.handleCreate(withoutPrint)
					} else {
						this.handleUpdate(withoutPrint);
					}
				}
				else {
          // 還原關係人資料
          this.weakApply.kinshipList = orgKinshipList;
					bootbox.alert("請確認必填欄位是否有填寫正確，並至少填寫兩名關係人完整資料");
				}
			});
		},
		handleCreate(withoutPrint) {
			const api = "/api/weak";
			let formData = new FormData();

			this.stu.deptCode = this.stu.ssym + this.stu.dept;

			for(let key in this.stu) {
				if(this.stu[key]) {
					formData.append(`stu.${key}`, this.stu[key]);
				}
			}
			for(let key in this.weakApply) {
				if(this.weakApply[key]) {
					if(typeof(this.weakApply[key]) === "object") {
						if(Array.isArray(this.weakApply[key])) {
							for(let i = 0; i < this.weakApply[key].length; i++) {
								for(let k in this.weakApply[key][i]) {
									if(this.weakApply[key][i][k]) {
										formData.append(`weakApply.${key}[${i}].${k}`, this.weakApply[key][i][k]);
									}
								}
							}
						} else {
							formData.append(`weakApply.${key}`, JSON.stringify(this.weakApply[key]));
						}
					} else {
						formData.append(`weakApply.${key}`, this.weakApply[key]);
					}
				}
			}

			formData.append("householdFile", this.householdFile)
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					this.weakApply.id = res.data.data.id;
					this.weakApply.year = res.data.data.year;
					if(withoutPrint) {
            			// 儲存未送出申請
						if(JSON.stringify(this.sessionData) != '{}') {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成線上申請。");
							this.gotoView('weak.list');
						} else {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成線上申請。<br/>若無法當下完成申請書上傳可透過「弱勢助學金申請查詢」功能，完成最後上傳步驟。");
							this.gotoView('weak.list', {idNo: this.stu.idno});
						}
					} else {
						this.showPrintPopup(true)
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		handleUpdate(withoutPrint) {
			if ((!this.weakApply.schReviewState || this.weakApply.schReviewState == '0' ||
				((this.weakApply.schReviewState == '4' || this.weakApply.schReviewState == '5') &&
				!this.isAdmin('assist'))) && !this.isShowPrintBtn) {
				this.submitApply();
			} else {
				const api = `/api/weak/${this.weakApply.id}`;
				let formData = new FormData();

				this.stu.deptCode = this.stu.ssym + this.stu.dept;
				for(let key in this.stu) {
					if(this.stu[key]) {
						formData.append(`stu.${key}`, this.stu[key]);
					}
				}

				for(let key in this.weakApply) {
					if(this.weakApply[key]) {
						if(typeof(this.weakApply[key]) === "object") {
							if(Array.isArray(this.weakApply[key])) {
								for(let i = 0; i < this.weakApply[key].length; i++) {
									for(let k in this.weakApply[key][i]) {
										if(this.weakApply[key][i][k]) {
											formData.append(`weakApply.${key}[${i}].${k}`, this.weakApply[key][i][k]);
										}
									}
								}
							} else {
								formData.append(`weakApply.${key}`, JSON.stringify(this.weakApply[key]));
							}
						} else {
							formData.append(`weakApply.${key}`, this.weakApply[key]);
						}
					}
				}

				formData.append("householdFile", this.householdFile);
        formData.append("affidavitFile", this.affidavitFile);
        formData.append("discardIncomeFile", this.discardIncomeFile);
				this.$axios.post(api, formData).then(res => {
					if(res.data.status === "success") {
						if ((!this.weakApply.schReviewState || this.weakApply.schReviewState == '0' || this.weakApply.schReviewState == '4'|| this.weakApply.schReviewState == '5') && this.isShowPrintBtn) {
							if(withoutPrint) {
								this.isShowPrintBtn = false;
								if(this.weakApply.schReviewState == '4'|| this.weakApply.schReviewState == '5'){
									// 補件
									bootbox.dialog({
										message: "儲存成功。<br/>請選擇是否沿用原本的申請書申請或是重新上傳？",
										buttons: {
											upload: {
												label: '重新上傳',
												callback: () => {
													this.$parent.isShowPrintBtn = false;
													this.affidavitFilePreview = null
												}
											},
											submit: {
												label: '送出申請',
												callback: () => {
													this.submitApply();
												}
											}
										}
									})
								} else {
									// 儲存未送出申請
									if(JSON.stringify(this.sessionData) != '{}') {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成申請。");
										this.gotoView('weak.list');
									} else {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成申請。<br/>若無法當下完成申請書上傳可透過「弱勢助學金申請查詢」功能，完成最後上傳步驟。");
										this.gotoView('weak.list', {idNo: this.stu.idno});
									}
								}
							} else {
								this.showPrintPopup(true)
							}
						} else if(this.isAdmin('assist')) {
							this.gotoView('weak.list')
						}
					} else if(res.data.status === "error") {
						bootbox.alert(res.data.msg);
					}
				});
			}
		},
		submitApply() {
			const api = `/api/weak/${this.weakApply.id}/affidavit`;
			let formData = new FormData();
			formData.append("affidavitFile", this.affidavitFile);
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					if(JSON.stringify(this.sessionData) != '{}') {
						bootbox.alert("線上申請成功，可至弱勢助學金申請列表，來查詢申請狀態。<br/><b>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('weak.list');
					} else {
						bootbox.alert("線上申請成功，可透過「弱勢助學金申請查詢」功能，以身分證字號來查詢申請狀態。<br/><b style='color:red;'>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('weak.list', {idNo: this.stu.idno})
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		syncSchoolFee(){
			const api = `/api/weak/syncSchoolFee`;
			this.$axios.post(api).then(res => {
				if(res.data.status === "success") {
					bootbox.alert("同步完成");
					this.pageInit();
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		getHouseholdFile(event) {
			this.householdFile = event.target.files[0];
			if(this.householdFile){
				if(this.checkFileExtension(this.householdFile.name, ["jpg","jpeg","png","pdf"])){
					this.weakApply.householdFile = this.householdFile.name;
					if (/^image/.test(this.householdFile.type)){
						this.compresImage(this.householdFile).then(result => {
							this.householdFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.householdFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
    getDiscardIncomeFile(event) {
      this.discardIncomeFile = event.target.files[0];
      if(this.discardIncomeFile){
        if(this.checkFileExtension(this.discardIncomeFile.name, ["jpg","jpeg","png","pdf"])){
          this.weakApply.discardIncomeFile = this.discardIncomeFile.name;
          if (/^image/.test(this.discardIncomeFile.type)){
            this.compresImage(this.discardIncomeFile).then(result => {
              this.discardIncomeFile = result;
            });
          }
        }else{
          bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
          this.discardIncomeFile = null;
        }
      }else{
        bootbox.alert("上傳失敗，請重新上傳。");
      }
    },
		getAffidavitFile(event) {
			this.affidavitFile = event.target.files[0];
			if(this.affidavitFile){
				if(this.checkFileExtension(this.affidavitFile.name, ["jpg","jpeg","png","pdf"])){
					this.weakApply.affidavitFile = this.affidavitFile.name;
					if (/^image/.test(this.affidavitFile.type)){
						this.compresImage(this.affidavitFile).then(result => {
							this.affidavitFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.affidavitFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		anyKinshipHasValue(kinship) {
			return !!kinship.kinshipType || !!kinship.status || !!kinship.occupationType || !!kinship.name || !!kinship.idNo;
		},
		showPrintPopup(isOpen) {
			this.isShowPrintPopup = isOpen
		},
		backToEdit() {
			this.isShowPrintBtn = true;
		},
		async getResiArea() {
			this.stu.resiAreaId = "";
			this.stu.resiRoadId = "";
			this.stu.resiAreaList = [];
			this.stu.resiRoadList = [];
			const api = "/api/Common/getArea/" + this.stu.resiCityId;
			let resp = await this.$axios.post(api);
			if(resp.data.status == "success"){
				this.areaList = resp.data.data.areaList;
			}
		},
		IsPdf(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		IsValidPreviewExt(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		getPreviewUrl(filePath) {
			let url = "";
			if(this.IsValidPreviewExt(filePath)) {
				url = "/upload/" + filePath;
			}
			return url;
		},
		display() {
			document.getElementById("box").style.display = "block";
		},
		disappear() {
			document.getElementById("box").style.display = "none";
		},
    getClassText(value) {
      switch (value){
        case "1":
          return "第一級";
        case "2":
          return "第二級";
        case "3":
          return "第三級";
        case "4":
          return "第四級";
        case "5":
          return "第五級";
        case "6":
          return "第六級";
        default:
          return ""
      }
    },
    clearKinship(index) {
      this.weakApply.kinshipList.splice(index, 1);
      this.weakApply.kinshipList.push({
        kinshipType: "",
        status: "",
        occupationType: ""
      });
    },
    isKinshipDeletable(kinship){
      // 管理員在待審狀態可以編輯
      if(!this.isAdmin('assist') || !(this.weakApply.schReviewState == "1" || this.weakApply.schReviewState == "6")) {
        return false;
      }
      // 有兩個以上關係人
      if(this.weakApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin)).length === 1) {
        return false;
      }
      // 關係人狀態為「離」
      if(!!kinship && kinship.status !== 'D') {
        return false;
      }
      return true;
    },
    getLastYearData() {
      if(this.isAdmin('assist') && this.stu.account.length == 9) {
        let api = `/api/weak/lastYearData?account=${this.stu.account}`;
        this.$axios.get(api).then(res => {
          if (res.data.status == "success") {
            if(res.data.data != null){
              this.stu = {
                ...res.data.data.stu,
                ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
                dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
              };

              if(res.data.data.lastWeakApply != null && res.data.data.lastWeakApply.id != "") {
                this.weakApply.kinshipList = res.data.data.lastWeakApply.kinshipList;
                this.weakApply.discardIncomeFile = res.data.data.lastWeakApply.discardIncomeFile;

                // 補足三個關係人資料
                for(let i=0; i<3; i++){
                  if(res.data.data.lastWeakApply.kinshipList.length <= i ){
                    this.weakApply.kinshipList[i] = {
                      kinshipType: "",
                      status: "",
                      occupationType: ""
                    }
                  }
                }
              }
            }
          } else if(res.data.status == "error"){
            bootbox.alert(res.data.msg);
            this.$router.back();
          }
        });
      }
    }
	},
	computed: {
		isInfo(){
			return this.$route.name != "weak.apply.new" || this.sessionData.accountType == "STU";
		},
		isEditable(){
			// 管理員在待審狀態可以編輯
			// 申請人或透過身分證查詢在草稿或待補件狀態可以編輯
			return (this.isAdmin('assist') && (this.weakApply.schReviewState == "1" || this.weakApply.schReviewState == "6")) ||
			 (this.sessionData.account == this.weakApply.account && (
				 this.weakApply.schReviewState == "0" || this.weakApply.schReviewState == "4"|| this.weakApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (this.isFromIdnoSearch && (
				 this.weakApply.schReviewState == "0" || this.weakApply.schReviewState == "4"|| this.weakApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (!this.weakApply.schReviewState && this.isShowPrintBtn);
		}
	},
	watch:{
		"stu.idno": function (val) {
			if(val){
				this.stu.idno = val.toUpperCase();
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>
</style>
